import { api, apiComm } from "./api-core";

export interface Tags {
  id?: number;
  name?: string;
  created_at?: string;
  updated_at?: string;
}

export interface ITagForm {
  id?: string;
  name: string;
}

export interface ITopicForm {
  title: string;
  content: string;
  author: string;
  tags?: Tags[];
}

export interface ITopic {
  status: boolean;
  code: string;
  data: {
    id?: string;
    title?: string;
    content?: string;
    author?: string;
    likes?: string;
    comments?: string;
    views?: string;
    status?: number;
    created_at?: string;
    updated_at?: string;
    tags?: Tags[];
  }[];
  total: number;
}

export interface ITopicInfo {
  status: boolean;
  code: string;
  data: {
    id?: string;
    title?: string;
    content?: string;
    author?: string;
    likes?: string;
    comments?: string;
    views?: string;
    status?: number;
    created_at?: string;
    updated_at?: string;
    tags?: Tags[];
    comments_list?: {
      id?: number;
      user?: string;
      comment_text?: string;
      created_at?: string;
    }[];
    likes_list?: {
      id?: number;
      user?: string;
      topic_id?: string;
    }[];
    views_list?: {
      id?: number;
      user?: string;
      topic_id?: string;
    }[];
  };
}

export interface IUserForum {
  status: boolean;
  code: string;
  data: {
    id: string; // ID của forum (dữ liệu trả về dạng string)
    title: string; // Tiêu đề forum
    content: string; // Nội dung forum
    date: string; // Ngày tạo forum
    modified: string; // Ngày cập nhật gần nhất
    author: {
      id: string; // ID của tác giả (string)
      name: string; // Tên hiển thị của tác giả
      avatar: string; // Ảnh đại diện của tác giả
    };
    total_topic_count: number; // Tổng số topic trong forum
    group: {
      id: string; // ID của group (string)
      creator_id: string; // ID người tạo group
      name: string; // Tên group
      slug: string; // Slug của group
      description: string; // Mô tả group
      status: string; // Trạng thái group (public/private/hidden)
      parent_id: string; // ID group cha
      enable_forum: string; // Trạng thái bật/tắt forum trong group
      date_created: string; // Ngày tạo group
      args: null | string; // Tham số bổ sung (hiện tại null)
      avatar_urls: {
        thumb: string; // Ảnh thumbnail của group
        full: string; // Ảnh full-size của group
      };
    };
  }[];
  pagination: {
    current_page: number;
    per_page: number;
    total_items: number;
    total_pages: number;
  }
  message: string;
  login_url: string;
}

export interface IForumInfo {
  status: boolean;
  code: string;
  data: {
    id?: string;
    date?: string;
    modified?: string;
    author?: {
      id?: string; // ID của tác giả (string)
      name?: string; // Tên hiển thị của tác giả
      avatar?: string; // Ảnh đại diện của tác giả
    };
    title?: string;
    content?: string;
    short_content?: string;
    total_reply: string;
    total_favourite?: number;
    total_subscibe?: string;
    forum_id?: string;
  }[];
}

export interface IDiscussionInfo {
  status: boolean;
  code: string;
  data: {
    id: string;
    title: string;
    content: string;
    date: string;
    modified: string;
    author: {
      id: string; // ID của tác giả (string)
      name: string; // Tên hiển thị của tác giả
      user_name: string;
      avatar: string; // Ảnh đại diện của tác giả
    };
    total_favourite: number;
    total_subscibe: number;
    favourites: {
      id: string;
      name: string;
      user_name: string;
      avatar: string;
    }[];
    subscribers: {
      id: string;
      name: string;
      user_name: string;
      avatar: string;
    }[];
    comments: {
      id: string;
      author: {
        id: string; // ID của tác giả (string)
        name: string; // Tên hiển thị của tác giả
        user_name: string;
        avatar: string; // Ảnh đại diện của tác giả
      };
      date: string;
      content: string;
    }[];
  };
  message: string;
}

export const TopicApi = {
  getListTopic: (status?: any) => {
    if (!status) {
      var url = `${process.env.API_GET_LIST_TOPIC}`;
    } else {
      var url = `${process.env.API_GET_LIST_TOPIC}?status=${status}`;
    }

    return api
      .get(url as string)
      .then((res) => {
        return res.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },
  getTrendingTopic: (status?: any, limit?: any) => {
    const params = new URLSearchParams();
    if (status) params.append("status", status);
    if (limit) params.append("limit", limit);

    const url = `${process.env.API_GET_TRENDING_TOPIC}?${params.toString()}`;

    return api
      .get(url as string)
      .then((res) => {
        return res.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },
  getTopicById: (id: string) => {
    const url = `${process.env.API_GET_TOPIC_BY_ID}?id=${id}`;
    return api
      .get(url as string)
      .then((res) => {
        return res.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },
  getDiscussionDetailById: (id: string) => {
    const url = `${process.env.API_GET_DISCUSSION_DETAIL}?topic_id=${id}`;
    return apiComm
      .get(url as string)
      .then((res) => {
        return res.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },
  updateDiscussionLike: (data: { topic_id?: string; username?: string }) => {
    const formData = new FormData();

    // Duyệt qua tất cả các trường trong data và thêm vào formData
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (Array.isArray(value)) {
          // Xử lý trường hợp là mảng
          value.forEach((item) => {
            formData.append(`${key}[]`, item.toString());
          });
        } else if (typeof value === "object" && !Array.isArray(value)) {
          // Xử lý trường hợp là đối tượng (ví dụ: parent)
          Object.entries(value).forEach(([subKey, subValue]) => {
            if (subValue !== undefined && subValue !== null) {
              // Sử dụng cú pháp đúng cho FormData
              formData.append(`${key}[${subKey}]`, subValue.toString());
            }
          });
        } else {
          // Xử lý các trường đơn
          formData.append(key, value.toString());
        }
      }
    });

    const url = process.env.API_FAVOURITE_DICUSSION;

    return apiComm
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error:", err);
        throw err; // Ném lỗi để xử lý ở nơi gọi hàm
      });
  },

  updateDiscussionComment: (data: {
    username?: string;
    topic_id?: string;
    content?: string;
  }) => {
    const formData = new FormData();

    // Duyệt qua tất cả các trường trong data và thêm vào formData
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (Array.isArray(value)) {
          // Xử lý trường hợp là mảng
          value.forEach((item) => {
            formData.append(`${key}[]`, item.toString());
          });
        } else if (typeof value === "object" && !Array.isArray(value)) {
          // Xử lý trường hợp là đối tượng (ví dụ: parent)
          Object.entries(value).forEach(([subKey, subValue]) => {
            if (subValue !== undefined && subValue !== null) {
              // Sử dụng cú pháp đúng cho FormData
              formData.append(`${key}[${subKey}]`, subValue.toString());
            }
          });
        } else {
          // Xử lý các trường đơn
          formData.append(key, value.toString());
        }
      }
    });

    const url = process.env.API_REPLY_DICUSSION;

    return apiComm
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error:", err);
        throw err; // Ném lỗi để xử lý ở nơi gọi hàm
      });
  },

  updateDiscussionSubscribe: (data: { topic_id?: string; username?: string }) => {
    const formData = new FormData();

    // Duyệt qua tất cả các trường trong data và thêm vào formData
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (Array.isArray(value)) {
          // Xử lý trường hợp là mảng
          value.forEach((item) => {
            formData.append(`${key}[]`, item.toString());
          });
        } else if (typeof value === "object" && !Array.isArray(value)) {
          // Xử lý trường hợp là đối tượng (ví dụ: parent)
          Object.entries(value).forEach(([subKey, subValue]) => {
            if (subValue !== undefined && subValue !== null) {
              // Sử dụng cú pháp đúng cho FormData
              formData.append(`${key}[${subKey}]`, subValue.toString());
            }
          });
        } else {
          // Xử lý các trường đơn
          formData.append(key, value.toString());
        }
      }
    });

    const url = process.env.API_SUBSCRIBE_DICUSSION;

    return apiComm
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error:", err);
        throw err; // Ném lỗi để xử lý ở nơi gọi hàm
      });
  },

  getUserForums: (username: any, page?: any, per_page?: any) => {
    var url = `${process.env.API_GET_USER_GROUPS_FORUM}${username}?page=${page}&per_page=${per_page}`;

    return apiComm
      .get(url as string)
      .then((res) => {
        return res.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },

  getDetailForum: (forum_id: any, page?: any, per_page?: any) => {
    var url = `${process.env.API_GET_FORUM_DETAIL}?forum_id=${forum_id}&page=${page}&per_page=${per_page}`;

    return apiComm
      .get(url as string)
      .then((res) => {
        return res.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },
};
